// extracted by mini-css-extract-plugin
export default {"component":"AG8ddg","h1":"H_UBFV","h2":"pE1iJ2","h3":"ykHket","h4":"T5vLiP","h5":"UVOln1","adaptive":"EoIRP5","styled":"GxnoaJ"};